export default __webpack_public_path__ + "static/media/projecticon.a9945c9b.svg";